export var ForwarderType;
(function (ForwarderType) {
    ForwarderType[ForwarderType["Port"] = 0] = "Port";
    ForwarderType[ForwarderType["AirLine"] = 1] = "AirLine";
})(ForwarderType || (ForwarderType = {}));
export var CommonlyUsePortType;
(function (CommonlyUsePortType) {
    CommonlyUsePortType[CommonlyUsePortType["CN"] = 0] = "CN";
    CommonlyUsePortType[CommonlyUsePortType["Collection"] = 1] = "Collection";
})(CommonlyUsePortType || (CommonlyUsePortType = {}));
